// imports
import styled from 'styled-components';

// styling
const SectionWrapper = styled.section`
  width: 100%;
  padding: 100px 0;

  i {
    padding-right: 20px;

    svg {
      width: 24px;
      height: 24px;
    }
    
    &#iOS {
      svg {
        margin-bottom: 6px;
      }
    }
    &#cpp {
      svg {
        margin-bottom: 1px;
      }
    }
  }

  .docs_link {
    left: 82%;
    width: 18%;
    bottom: 160px;
    position: relative;

    color: #45a4f7;
    font-size: 16px;
    font-weight: 600;
    line-height: 28px;
    font-family: Open Sans, sans-serif;

    &::before {
      top: -10px;
      left: 0;
      z-index: -1;
      content: '';
      width: 100%;
      height: 1px;
      display: block;
      position: absolute;
      background: #e7e8eb;
    }

    &:hover {
      color: #3072ac;
    }

    @media only screen and (max-width: 991px) {
      display: none;
    }
  }

  .snippets_integration_dropdown {
    display: none;
    margin-bottom: 10px;

    color: #45a4f7;
    font-size: 16px;
    font-weight: 600;
    line-height: 40px;
    font-family: Open Sans,sans-serif;

    @media only screen and (max-width: 991px) {
      display: block;
    }
  }

  .titleHeading {
    width: 540px;
    max-width: 100%;
    margin-left: auto;
    margin-right: auto;
    
    color: #0f2137;
    font-weight: 400;
    line-height: 1.12;
    text-align: center;
  }

  .rq_tab {
    display: flex;
    flex-direction: row-reverse;
    
    .tab_content {
      width: 80%;
      @media only screen and (max-width: 991px) {
        width: 100%;
      }
    }
    
    .tab_menu {
      width: 20%;
      display: flex;
      min-height: 420px;
      padding-left: 10px;
      justify-content: top;
      flex-direction: column;

      @media only screen and (max-width: 991px) {
        display: none;
      }

      li {
        color: #45a4f7;
        font-size: 16px;
        font-weight: 600;
        line-height: 40px;
        position: relative;
        padding-left: 15px;
        transition: color 0.325s ease;
        font-family: Open Sans, sans-serif;

        &:hover {
          color: #3072ac;
        }

        &.active {
          color: #24b47e;
          font-weight: 700;
          background-color: white;
          box-shadow: 0px 2px 4px rgba(50,50,93,.1);

          transition: box-shadow 0.6s linear;
          transition: background-color 0.6s linear;
        }
      }
    }
  }
`;

// exports
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 991px) {
    flex-direction: wrap;
  }

  .content {
    width: 100%;

    pre {
      margin: 0;
      // word-break: break-all;
      // white-space: pre-wrap;
      background: white !important;
      box-shadow: 0px 2px 4px rgba(50,50,93,.1);
      
      code:first-of-type {
        color: #5dc79e;
        margin: -0.5em;
        text-align: right;
        margin-right: 1em;
        background: #f2feef;
        padding: 0.5em 10px 0.5em 10px;
      }
    }
  }
`;

export default SectionWrapper;